module.exports = __webpack_public_path__ + "img/Asian Quinoa Bowl-Chicken.b9c3fea5.jpg";